import { Typography } from 'Components/atoms';
import { DateTimeFormatter } from 'Core-utils/helpers/helpers';
import { normalizeLastUpdatedAt } from 'Core-utils/helpers/pageHints';
import './GridDataFreshnessLabel.scss';

export { isValidLastUpdatedAtIso, normalizeLastUpdatedAt, readLastUpdatedAtHint } from 'Core-utils/helpers/pageHints';

export interface GridDataFreshnessLabelProps {
  lastUpdatedAt?: string | null;
  className?: string;
}

export function GridDataFreshnessLabel({ lastUpdatedAt, className }: GridDataFreshnessLabelProps) {
  const normalizedLastUpdatedAt = normalizeLastUpdatedAt(lastUpdatedAt);
  if (!normalizedLastUpdatedAt) {
    return null;
  }

  return (
    <Typography
      variant="body10"
      color="text-low-emphasis"
      className={['grid-data-freshness', className].filter(Boolean).join(' ')}
    >
      Last updated at {DateTimeFormatter(normalizedLastUpdatedAt)}
    </Typography>
  );
}
